import { render, staticRenderFns } from "./Calculator.vue?vue&type=template&id=1563e7d2&scoped=true"
import script from "./Calculator.vue?vue&type=script&lang=js"
export * from "./Calculator.vue?vue&type=script&lang=js"
import style0 from "./Calculator.vue?vue&type=style&index=0&id=1563e7d2&prod&lang=scss&scoped=true"
import style1 from "./Calculator.vue?vue&type=style&index=1&id=1563e7d2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1563e7d2",
  null
  
)

export default component.exports